/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseAsdSicherheitsbriefDto } from '../../models/response-asd-sicherheitsbrief-dto';

export interface GetAllAsdSicherheitsbrief$Params {
  fileName?: string;

/**
 * filter upload date by range from/to
 */
  uploadDate?: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export function getAllAsdSicherheitsbrief(http: HttpClient, rootUrl: string, params?: GetAllAsdSicherheitsbrief$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAsdSicherheitsbriefDto>> {
  const rb = new RequestBuilder(rootUrl, getAllAsdSicherheitsbrief.PATH, 'get');
  if (params) {
    rb.query('fileName', params.fileName, {});
    rb.query('uploadDate', params.uploadDate, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseAsdSicherheitsbriefDto>;
    })
  );
}

getAllAsdSicherheitsbrief.PATH = '/documents/asd-sicherheitsbrief';
